import useDataFreshness from '../hooks/useDataFreshness.js';

// Warns when the DC DMS → UTSales sales sync has gone stale, so users don't
// trust frozen parts/service/trailer revenue numbers. Hidden when fresh.
export default function DataFreshnessBanner() {
  const sync = useDataFreshness();
  if (!sync || !sync.stale) return null;

  const when = sync.last_success_at
    ? new Date(sync.last_success_at).toLocaleString(undefined, {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
      })
    : 'never';

  return (
    <div className="bg-crimson/10 border-b border-crimson/40 px-4 py-2 text-sm text-crimson flex items-center gap-2">
      <span className="text-base">⚠</span>
      <span>
        Sales data sync is stale — parts, service &amp; trailer revenue last updated <b>{when}</b>.
        Figures may be out of date; the team has been alerted.
      </span>
    </div>
  );
}
